var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97591 10V12.9167C9.97591 14.525 11.2842 15.8333 12.8926 15.8333C14.5009 15.8333 15.8092 14.525 15.8092 12.9167V8.33333C15.8092 5.10833 13.2009 2.5 9.97591 2.5C6.75091 2.5 4.14258 5.10833 4.14258 8.33333V13.3333C4.14258 16.0917 6.38425 18.3333 9.14258 18.3333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.c8c84d4de1eecaac992c7e4c855e1bfd.svg";
export { ForwardRef as ReactComponent };